




































































































































import { defineComponent } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import { getMetaInfo } from '~/helpers/getMetaInfo';
export default defineComponent({
    components: {
        SfLink,
    },
    setup () {
        const pageMeta = {
            "meta_title": null,
            "meta_description": null,
            "meta_keywords": null,
            "name": "Midwest Photo Services",
        };
        return {
            pageMeta
        }
    },
    head() {
        return getMetaInfo(this.pageMeta);
    },
});
